<nz-skeleton *ngIf="isFetchingAuthDetails" [nzParagraph]="{ rows: 10 }"></nz-skeleton>

<!-- Connected -->
<ng-container *ngIf="!isFetchingAuthDetails && authDetails != null && authDetails.connectionStatus">
  <!-- Card 1: connection details -->
  <nz-card>
    <div class="d-flex justify-content-space-between">
      <div class="fs-30">Shopify Connection</div>
      <div class="right">
        <button nz-button nzType="primary" (click)="ShopifyAuthConnectionTest('test')"
          [nzLoading]="isTestingConnection">Test Connection</button>
      </div>
    </div>
    <hr />
    <div class="fs-18">
      <div class="d-flex m-1">
        <div class="w-50 fw-bold">Connection Status</div>
        <div>
          <span nz-icon nzType="check-circle" nzTheme="outline" class="cl-green"></span>
          Connected
        </div>
      </div>
      <div class="d-flex m-1">
        <div class="w-50 fw-bold">Store Name</div>
        <div>{{ authDetails.storeName || authDetails.storeDomain }}</div>
      </div>
      <div class="d-flex m-1">
        <div class="w-50 fw-bold">Store Domain</div>
        <div>{{ authDetails.storeDomain }}</div>
      </div>
      <div class="d-flex m-1">
        <div class="w-50 fw-bold">Access Token</div>
        <div class="cursor" nz-tooltip nzTooltipPlacement="topLeft"
          [nzTooltipTitle]="authDetails.accessToken"
          [nzTooltipOverlayStyle]="{ 'max-width': '420px', 'word-break': 'break-all' }">
          {{ authDetails.accessToken.slice(0, 15) }}...
        </div>
      </div>
      <div class="d-flex m-1">
        <div class="w-50 fw-bold">Connected At</div>
        <div>{{ authDetails.connectedAt | date: 'MM/dd/yyyy hh:mm:ss a' }}</div>
      </div>
      <div class="d-flex m-1">
        <div class="w-50 fw-bold">Scope</div>
        <div class="cursor" nz-tooltip nzTooltipPlacement="topLeft"
          [nzTooltipTitle]="authDetails.scope"
          [nzTooltipOverlayStyle]="{ 'max-width': '420px', 'word-break': 'break-all' }">
          {{ authDetails.scope.slice(0, 15) }}...
        </div>
      </div>
      <div class="m-1 mt-2">
        <button nz-button (click)="disconnectFromShopify()" [nzLoading]="isDisconnecting"
          class="modal-footer-btn cancel-btn w-auto">Disconnect</button>
      </div>
    </div>
  </nz-card>

  <!-- Card 2: webhooks table -->
  <nz-card class="mt-2">
    <div class="d-flex justify-content-space-between">
      <div class="fs-30">Webhooks</div>
      <div class="right">
        <!--
          Register / Deregister Webhooks buttons hidden per request.
          Registration is now triggered automatically on Shopify connect, and
          deregistration on disconnect. Kept here (and the registerWebhooks() /
          deregisterWebhooks() methods + service APIs intact) for future use.
        <button nz-button nzType="primary" (click)="registerWebhooks()"
          [nzLoading]="isRegisteringWebhooks" class="webhook-btn">Register Webhooks</button>
        <button nz-button (click)="deregisterWebhooks()" [nzLoading]="isDeregisteringWebhooks"
          class="modal-footer-btn cancel-btn webhook-btn">Deregister Webhooks</button>
        -->
      </div>
    </div>
    <hr />
    <nz-table #webhookTable [nzData]="webhookRows" [nzLoading]="isLoadingWebhooks"
      [nzShowPagination]="false" nzSize="middle">
      <thead>
        <tr>
          <th nzWidth="60px">#</th>
          <th nzWidth="220px">Topic</th>
          <th>Address</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of webhookTable.data; index as i">
          <td>{{ i + 1 }}</td>
          <td>{{ row.topic }}</td>
          <td class="webhook-address">{{ row.address }}</td>
        </tr>
      </tbody>
    </nz-table>
  </nz-card>
</ng-container>

<!-- Disconnected / token invalid — show connect action -->
<div *ngIf="!isFetchingAuthDetails && (authDetails == null || !authDetails.connectionStatus)"
  class="connectBtnContainer">
  <p *ngIf="isConnectionError" class="text-danger fs-18 mb-2">
    Token invalid or revoked — reconnect required.
  </p>
  <p *ngIf="!isConnectionError" class="fw-bold fs-18 mb-2">Not connected to Shopify.</p>
  <a *ngIf="shopifyAuthUrl" nz-button nzType="primary" [href]="shopifyAuthUrl">Connect to Shopify</a>
  <button *ngIf="!shopifyAuthUrl" nz-button nzType="primary" disabled>Connect to Shopify</button>
</div>
